export const ptrSubdomainValidator = (value) => {
    if (!value) return "validate.ptr_subdomain_required";

    if (value === "@") return "validate.ptr_subdomain_not_root";

    // Проверка на формат обратной зоны IP (например, 1.0.0.10.in-addr.arpa)
    const regex = /^(\d{1,3}\.){1,4}(in-addr|ip6)\.arpa$/;
    return regex.test(value) ? true : "validate.ptr_subdomain_format";
}; 